<template>
  <div class="flow-priority-next issue-next">
    <div class="issue-action" @click="showDlg">{{btnText}}</div>
    <el-dialog
      title="流量优选开启确认"
      :visible.sync="dialogVisible"
      width="800px"
      custom-class="suggest-custom-dlg"
      :before-close="handleClose">
      <p class="suggest-text">账户内<span class="main-text">{{count}}条</span>计划可使用流量优选功能，是否一键批量开启？</p>
      <a href="/v2/dist/suggest.html#/featureRec">前往查看流量优选可开启计划列表 <i class="el-icon-arrow-right"></i></a>
      <span slot="footer" class="dialog-footer">
        <div class="issue-dlg-btn normal-btn" @click="handleClose">取消</div>
        <div class="issue-dlg-btn main-btn" @click="submit">确定</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {getFeatureCampaign, batchFlowPriority} from '../utils/api.js';
  const logParams = {
    pageLevel1: 'account_homepage',
    pageLevel2: 'delivery_suggestion',
    pageLevel3: 'delivery_suggestion',
    element_name: 'open_flow_priority_adopt',
  };
  export default {
    name: 'flow-priority-next',
    props: {
      btnText: {
        type: String,
        default: '一键开启'
      }
    },
    data() {
      return {
        dialogVisible: false,
        count: 0,
        list: []
      }
    },
    methods: {
      handleClose(done) {
        this.dialogVisible = false;
      },
      async showDlg() {
        this.$log('click', {
          ...logParams,
          element_name: 'flow_priority_next_step'
        });
        const result = await getFeatureCampaign({
          issueType: 'FLOW_PRIORITY',
          queryAll: true
        });
        if (result) {
          this.count = result.conf.totalnum;
          this.list = result.list;
          this.dialogVisible = true;
          this.$log('expose', {
            ...logParams
          });
        }
      },
      async submit() {
        const params = {
          campaignIds: this.list.map(it => it.id).join(','),
          doOpen: true
        };
        const result = await batchFlowPriority(params);
        if (result && result.success) {
          this.dialogVisible = false;
          this.$log('click', {
            ...logParams,
            selected_ads_cnt: this.list.length,
            operated_ads_cnt: this.list.length
          });
          this.$message.success(`操作成功，账户内${this.list.length}条计划已开启流量优选。`);
        } else {
          this.$log('click', {
            ...logParams,
            selected_ads_cnt: this.list.length,
            operated_ads_cnt: 0
          });
        }
      }
    }
  }
</script>
<style lang="scss">
  @use '../assets/next.scss';
</style>